// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6h-0";
export var startPickingButton = "_6h-1";